import React, { Component } from 'react'
import './wizardDots.sass'
class WizardProgressDots extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dots: '',
    }
  }

  componentDidMount() {}

  makeDots = () => {
    let dots = []

    let currentClass = ''

    for (let i = 0; i < this.props.numDots; i++) {
      if (i + 1 === this.props.currentDot) {
        currentClass = 'active'
      }
      dots.push(<div className={'wizard-dot ' + currentClass}></div>)
      currentClass = ''
    }
    //console.log(dots)

    return dots
  }

  render() {
    return (
      <React.Fragment>
        {this.props.numDots > 0 && <div className="wizards-dots-wrap has-text-centered">{this.makeDots()}</div>}
      </React.Fragment>
    )
  }
}

export default WizardProgressDots

WizardProgressDots.defaultProps = {
  numDots: 0,
  currentDot: 0,
}
